/**
 * Shared Components
 *
 * 이 파일은 shared 컴포넌트들을 통합하여 export합니다.
 */

// LocaleSelector
export { LocaleSelector } from "./LocaleSelector";
export type {
  LocaleSelectorProps,
  LocaleSelectorVariant,
} from "./LocaleSelector";

// Avatar Component
export { Avatar } from "./Avatar";
export type {
  AvatarProps,
  AvatarSize,
  AvatarVariant,
  AvatarContent,
} from "./Avatar";

// Chip Component
export { Chip } from "./Chip";
export type { ChipProps, ChipAppearance } from "./Chip";

// RangeChip Component
export { RangeChip } from "./RangeChip";
export type { RangeChipProps, RangeChipSize } from "./RangeChip";

// StatusChip Component
export { StatusChip } from "./StatusChip";
export type { StatusChipProps } from "./StatusChip";

// Alert Component
export { Alert } from "./Alert";
export type { AlertProps, AlertType } from "./Alert";

// QueryStateView Component — 렌더 게이트 4갈래 + 저하 통지 배치
export { QueryStateView } from "./QueryStateView";
export type { QueryStateViewProps } from "./QueryStateView";

// TextField Component
export { TextField } from "./TextField";
export type {
  TextFieldProps,
  TextFieldSize,
  TextFieldState,
} from "./TextField";

// MultilineTextField Component
export { MultilineTextField } from "./MultilineTextField";
export type {
  MultilineTextFieldProps,
  MultilineTextFieldState,
} from "./MultilineTextField";

// Switch Component
export { Switch } from "./Switch";
export type { SwitchProps } from "./Switch";

// Tabs Component
export { Tabs } from "./Tabs";
export type { TabsContainerProps, TabsItemProps } from "./Tabs";

// ToggleButton Component
export { ToggleButton } from "./ToggleButton";

// ToggleButtonGroup Component
export { default as ToggleButtonGroup } from "./ToggleButtonGroup";
export type { ToggleButtonProps } from "./ToggleButton";

// DatePicker Component
export { DatePicker } from "./DatePicker";
export type { DatePickerProps } from "./DatePicker";

// ColorSelect Component
export { ColorSelect } from "./ColorSelect";
export type { ColorSelectProps } from "./ColorSelect";

// ProjectTable Component
export { ProjectTable } from "./ProjectTable/index";
export type {
  ProjectTableProps,
  ProjectData,
  ProjectRevealRequest,
} from "./ProjectTable/index";

// Icon Component
export { Icon } from "./Icon";
export type { IconProps } from "./Icon";

// IconButton Component
export { SpecifiedIconButton } from "./SpecifiedIconButton";
export type { SpecifiedIconButtonProps } from "./SpecifiedIconButton";

// Button Component
export { Button } from "./Button";
export type { ButtonProps } from "./Button";

// Checkbox Component
export { Checkbox } from "./Checkbox";
export type { CheckboxProps } from "./Checkbox";

// MenuList Component
export { MenuList } from "./MenuList";
export type { MenuListProps } from "./MenuList";

// MenuItem Component
export { MenuItem } from "./MenuItem";
export type { MenuItemProps } from "./MenuItem";

// ImageLoadingPlaceholder Component
export {
  ImageLoadingPlaceholder,
  IMAGE_FADE_IN_MS,
} from "./ImageLoadingPlaceholder";

// CardImage Component
export { CardImage } from "./CardImage";
export type { CardImageProps } from "./CardImage";

// CardHeader Component
export { CardHeader } from "./CardHeader";
export type { CardHeaderProps, CardHeaderSize } from "./CardHeader";

// Card Component
export { Card } from "./Card";
export type { CardProps, CardSize } from "./Card";

// ImageCard Component
export { ImageCard } from "./ImageCard";
export type { ImageCardProps } from "./ImageCard";

// FloatImageViewer Component
export { FloatImageViewer } from "./FloatImageViewer";
export type { FloatImageViewerProps } from "./FloatImageViewer";

// PointLocation Component
export { PointLocation } from "./PointLocation";

// MapImageViewer Component
export { MapImageViewer } from "./MapImageViewer";
export type { MapImageViewerProps } from "./MapImageViewer";

// DataTitle Component
export { DataTitle } from "./DataTitle";
export type { DataTitleProps } from "./DataTitle";

// DataCell Component
export { DataCell } from "./DataCell";
export type { DataCellProps, DataCellAreaProps } from "./DataCell";
export { RightContent } from "./DataCell";
export { CompareSection } from "./DataCell";
export { Label } from "./DataCell";
export { LoadingContent } from "./DataCell";
export type { ValueTextProps } from "./DataCell";
export type { CompareSectionProps } from "./DataCell";
export type { LabelProps } from "./DataCell";
export type { LoadingContentProps } from "./DataCell";

// IssueBox Component
export { IssueBox } from "./IssueBox";
export type {
  IssueBoxContainerProps,
  IssueBoxItemProps,
} from "./IssueBox/types";

// SideSpacer Component
export { SideSpacer } from "./SideSpacer";
export type { SideSpacerProps } from "./SideSpacer";

// SideMainHeader Component
export { SideMainHeader } from "./SideMainHeader";
export type { SideMainHeaderProps } from "./SideMainHeader";

// SideSub Component
export { SideSub } from "./SideSub";
export type { SideSubProps } from "./SideSub";

// ProjectHeader Component
export { ProjectHeader } from "./ProjectHeader";
export type { ProjectHeaderProps } from "./ProjectHeader";

// ListSelect Component
export { ListSelect } from "./ListSelect";
export type { ListSelectProps } from "./ListSelect";

// ModalHeader Component
export { ModalHeader } from "./ModalHeader";
export type { ModalHeaderProps, ModalHeaderSize } from "./ModalHeader";

// ModalBottom Component
export { ModalBottom } from "./ModalBottom";
export type { ModalBottomProps, ModalBottomIntent } from "./ModalBottom";

// DeleteConfirmDialog Component
export { DeleteConfirmDialog } from "./DeleteConfirmDialog";
export type { DeleteConfirmDialogProps } from "./DeleteConfirmDialog";

// SelectionActionDock Component
export { SelectionActionDock } from "./SelectionActionDock";
export type { SelectionActionDockProps } from "./SelectionActionDock";

// ApplicationSideBar Component
export { ApplicationSideBar } from "./SideBar/ApplicationSideBar";
export type {
  ApplicationSideBarProps,
  ApplicationSideBarRef,
} from "./SideBar/ApplicationSideBar";

// ProjectSideBar Component
export { ProjectSideBar } from "./SideBar/ProjectSideBar";
export type { ProjectSideBarProps } from "./SideBar/ProjectSideBar";

// IssueFilter Component
export { IssueFilter } from "./IssueFilter";
export type {
  ContainerProps,
  TypeFilterProps,
  CategoryFilterProps,
  DegreeFilterProps,
  GradeFilterProps,
  DateFilterProps,
} from "./IssueFilter";

// FileHeader Component
export { FileHeader } from "./FileHeader";
export type { FileHeaderProps } from "./FileHeader";

// FileProgress Component
export { FileProgress } from "./FileProgress";
export type { FileProgressProps } from "./FileProgress";

// FileList Component
export { FileList } from "./FileList";
export type { FileListProps, ItemProps, EmptyProps } from "./FileList";

// MapBottom Component
export { MapBottom } from "./MapBottom";
export type { MapBottomProps } from "./MapBottom";

// MapCoordinateInfo Component
export { MapCoordinateInfo } from "./MapCoordinateInfo";
export type { MapCoordinateInfoProps } from "./MapCoordinateInfo";

// DataList Component
export { DataList } from "./DataList";
export type { DataListProps, DataSection, ComparisonData } from "./DataList";

// ComparisonSection Component (for DataList)
export { ComparisonSection } from "./DataList/ComparisonSection";
export type { ComparisonSectionProps } from "./DataList/ComparisonSection";

// DragAndDrop Component
export { DragAndDrop, useDragAndDropContext } from "./DragAndDrop";
export type {
  DragAndDropProps,
  DragAndDropItemProps,
  DragAndDropContextValue,
} from "./DragAndDrop";

// Map3DControlsModal Component
export { Map3DControlsModal } from "./Map3DControlsModal";

// OverflowTooltip Component — 말줄임된 텍스트의 전체 내용을 실측 게이팅 hover 팝업으로
export { OverflowTooltip } from "./OverflowTooltip";
export type { OverflowTooltipProps } from "./OverflowTooltip";

// StateTransition Component — 조회 갈래 전환·스켈레톤·상태 칸·처리 중 라벨 원시와 모션·입력 토큰
export {
  BranchFade,
  SkeletonReveal,
  SkeletonBone,
  StateSlot,
  BusyLabel,
  LineGlyph,
  BRANCH_FADE_MS,
  SKELETON_SHOW_DELAY_MS,
  REVEAL_OPEN_MS,
  REVEAL_CLOSE_MS,
  HOVER_TRANSITION_MS,
  SWAP_FADE_MS,
  fadeIn,
  swapFadeCss,
  revealOpenCss,
  revealCloseCss,
  revealIdleCss,
  REDUCED_MOTION_SX,
  FIELD_BORDER,
  FIELD_HOVER_BORDER,
  FIELD_DISABLED_BG,
  SKELETON_BG,
  FOCUS_RING,
  MENU_SHADOW,
  ERROR_SURFACE,
  INFO_SURFACE,
  NEUTRAL_SURFACE,
  SUBTLE_SURFACE,
  CAPTION,
  ELLIPSIS,
  HOVER_SURFACE,
  FIELD_ERROR_POP_SX,
} from "./StateTransition";
export type {
  BranchFadeProps,
  SkeletonRevealProps,
  SkeletonBoneProps,
  StateSlotProps,
  StateSlotTone,
  StateSlotDensity,
  BusyLabelProps,
  LineGlyphProps,
  LineGlyphName,
} from "./StateTransition";

// ValueSelect Component — 값으로 고르는 검색형·버튼형 선택 콤보박스와 같은 모양의 메뉴 부품
export {
  ValueSelect,
  SELECT_FIELD_HEIGHT_PX,
  SELECT_MENU_MAX_HEIGHT_PX,
  SELECT_MENU_OPEN_MS,
  selectMenuOpenKeyframes,
  selectMenuCss,
  selectMenuAboveCss,
  selectFieldSx,
  selectInputSx,
  selectLabelSx,
  selectChevronSx,
  selectOptionSx,
  selectOptionLabelSx,
  selectOptionCheckSx,
  selectEmptySx,
  selectTextSizeSx,
} from "./ValueSelect";
export type {
  ValueSelectOption,
  ValueSelectProps,
  SelectFieldState,
  SelectSize,
} from "./ValueSelect";
